import { useLocation, Link } from "react-router-dom"

export default function Breadcrumbs() {
  const location = useLocation()
  //  console.log("Breadcrumbs ~ location", location)

  let currentLink = ''

  const crumbs = location.pathname.split('/')
    .filter(crumb => crumb !== '')
    .map(crumb => {
      currentLink += `/${crumb}`

      return (
        <div className="crumb" key={crumb} >
          <Link to={currentLink}>{crumb}</Link>
        </div>
      )
    })

  return (
    <div className="breadcrumbs" dir="rtl">
      {crumbs}
    </div>
  )
}